// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NXUWd","name":"styles_name__1J5Ym","phone":"styles_phone__1D_Zw"};